/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCompetitionService() {
        let competitionService = {};
        competitionService.getAllCampaigns = function (request){
            return axios.post("/api/CompetitionService/GetAllCampaigns", request)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.addOrUpdateCampaign = function (formData){
            return axios.post("/api/CompetitionService/AddOrUpdateCampaign", formData, { headers: {'Content-Type': 'multipart/form-data' }})
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.getSitesByCampaign = function (campaignId){
            return axios.get("/api/CompetitionService/GetSitesByCampaign?campaignId=" + campaignId)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.downloadBannerForCampaign = function (campaignId) {
            var win = window.open("/api/CompetitionService/DownloadBannerForCampaign?campaignId=" + campaignId, "_blank");
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this website');
            }
        };
        competitionService.generateCampaignLink = function (campaignId){
            return axios.get("/api/CompetitionService/GenerateCampaignLink?campaignId=" + campaignId)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.markCampaignAsActiveOrInactive = function (request){
            return axios.post("/api/CompetitionService/MarkCampaignAsActiveOrInactive", request)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.drawWinner = function (campaignId){
            return axios.get("/api/CompetitionService/DrawWinner?campaignId=" + campaignId)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        }
        competitionService.addOrUpdateCampaignWinner = function (request){
            return axios.post("/api/CompetitionService/AddOrUpdateCampaignWinner", request)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.downloadSubmissionTillSlip = function(request){
            return axios.post("/api/CompetitionService/DownloadSubmissionTillSlip", request, { responseType: 'blob' })
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.getWinningSubmissionByCampaign = function(campaignId){
            return axios.get("/api/CompetitionService/GetWinningSubmissionByCampaign?campaignId=" + campaignId)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        competitionService.getAllSubmissions = function (request){
            return axios.post("/api/CompetitionService/GetAllSubmissions", request)
                .then(response => {
                    return response;
                }).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        return competitionService;
    }
    //define globally if it doesn't already exist
    if (typeof (competitionService) === "undefined") {
        window.competitionService = defineCompetitionService();
    } else {
        console.log("competitionService already defined.");
    }
})(window);